import React from 'react';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';

const CTASection = () => {
  return (
    <section className="py-32 bg-black relative overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-5xl sm:text-6xl font-bold text-white mb-8">
            Prueba Cloudbase Gratis
          </h2>
          <p className="text-xl text-gray-300 mb-12 font-light">
            Nuestra prueba de 30 días incluye acceso completo a la plataforma y soporte dedicado.
          </p>
          
          <Button 
            size="lg" 
            className="bg-green-600 hover:bg-green-700 text-white px-10 py-7 text-base rounded font-semibold transition-all duration-200 inline-flex items-center gap-2"
            onClick={() => window.location.href = '/demo'}
          >
            Iniciar Prueba Gratuita
            <ArrowRight className="w-5 h-5" />
          </Button>
        </div>
      </div>
    </section>
  );
};

export default CTASection;